// extracted by mini-css-extract-plugin
module.exports = {"title":"h1_title__2R0aW"};